import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'

import { cn } from '@bem-react/classname'

import Icon from '@/components/UI/Icon'

import './Menu.scss'

interface IMenu {
  className?: string
}

const cnMenu = cn('Menu')

export const Menu: FC<IMenu> = ({ className }: IMenu) => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const data = [
    {
      id: 1,
      to: '/c',
      icon: 'home',
      title: t('menu-home'),
    },

    {
      id: 2,
      to: '/c/orders',
      icon: 'orders',
      title: t('menu-orders'),
    },
    {
      id: 4,
      to: '/c/affiliate',
      icon: 'affiliate',
      title: t('menu-affiliate'),
    },

    {
      id: 3,
      to: '/c/settings',
      icon: 'settings',
      title: t('menu-settings'),
    },
  ]

  return (
    <div className={cnMenu(null, [className])}>
      {data.map(el => (
        <NavLink
          key={el.id}
          to={el.to}
          className={cnMenu('link', { active: pathname === el.to })}
        >
          <Icon name={el.icon} className={cnMenu('icon')} />
          <span className={cnMenu('title')}>{el.title}</span>
        </NavLink>
      ))}
    </div>
  )
}
